import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconVimeo16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconVimeo16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M13.995 5.315q-.08 1.686-2.446 4.621Q9.096 13 7.404 13q-1.049 0-1.774-1.867l-.968-3.42q-.54-1.864-1.157-1.866-.135 0-.94.544L2 5.691q.89-.75 1.75-1.5 1.185-.985 1.778-1.038Q6.928 3.024 7.25 5q.35 2.13.48 2.653.405 1.767.889 1.766.378 0 1.131-1.146.753-1.147.807-1.746.109-.989-.807-.99a2.3 2.3 0 0 0-.888.19q.889-2.801 3.383-2.724 1.85.054 1.749 2.313"
            />
        </svg>
    );
}
export default memo(IconVimeo16);
